import { render, staticRenderFns } from "./OrderedCheckBox.vue?vue&type=template&id=cdfe44bc"
import script from "./OrderedCheckBox.vue?vue&type=script&lang=ts"
export * from "./OrderedCheckBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports